module.exports = __webpack_public_path__ + "img/aqi_bg.0dca4802.gif";